window.addEventListener('DOMContentLoaded', () => {
  const $productOasisExIn = document.querySelector('#productOasisExIn');
  if ($productOasisExIn) {
    const $homeOasisCanvas = document.querySelector('#oasisExIn');
    const path = $homeOasisCanvas.getAttribute('data-path');
    const frames = parseInt($homeOasisCanvas.getAttribute('data-frames'));
    const ctx = $homeOasisCanvas.getContext('2d');
    const canvasWidth = $homeOasisCanvas.width;
    const canvasHeight = $homeOasisCanvas.height;
    let currentFrame = index => (
        `${path}${String(index).padStart(4, '0')}.webp`
    );

    const images = [];
    const oasis = {
      frame: 0
    };

    function loadImagesWithLimit(frames, currentFrame, limit = 4) {
      const images = [];
      let index = 0;
      let active = 0;

      return new Promise((resolve, reject) => {
        function next() {
          if (index >= frames && active === 0) {
            resolve(images);
            return;
          }
          while (active < limit && index < frames) {
            const i = index++;
            active++;
            const img = new Image();
            img.src = currentFrame(i);
            img.onload = () => {
              images[i] = img;
              if ( i === 0 ) render(img); // Render the first image immediately
              active--;
              next();
            };
            img.onerror = reject;
          }
        }
        next();
      });
    }

// Usage
    loadImagesWithLimit(frames, currentFrame, 30).then(loadedImages => {
      images.push(...loadedImages);
      render();
    });

    gsap.to(oasis, {
      frame: frames - 1,
      snap: 'frame',
      ease: 'none',
      scrollTrigger: {
        trigger: $productOasisExIn,
        start: 'top 50%',
        end: 'bottom bottom',
        scrub: 1,
        // markers: true,
      },
      onUpdate: render
    });


    function render(renderImg = null) {
      const img = renderImg ? renderImg :  images[ oasis.frame];
      if (!img) return;
      ctx.clearRect(0, 0, canvasWidth, canvasHeight);
      ctx.drawImage(img, 0, 0);
    }

  }
})